// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { LogLevel } from '@core/logger';
import { EnvironmentBase } from '@env/environment.base';
import { LoginBehaviour } from '@env/LoginBehaviour';

export const environment: EnvironmentBase = {
  name: 'pasm',
  MultiMandantConfigs: [
    {
      host: 'pas-kpt-smartportal-frontend-prod.pasmapps.de',
      pathToAssets: 'https://pas-kpt-smartportal-frontend-prod.pasmapps.de/assets/pasm',
    },
  ],
  baseUrl: 'https://pas-kpt-smartportal-backend-prod.pasmapps.de',
  production: true,
  logLevel: LogLevel.All,
  hmr: false,
  AadClientId: '4a1f63ba-01bd-416d-b781-2b902ffcfe6f',
  AadScope: 'https://pasb2c.onmicrosoft.com/pas-kpt-smartportal-backend-prod/API.ACCESS',
  AadAuthorityDomain: 'pasb2c.b2clogin.com',
  AadSignupSigninUrl: 'https://pasb2c.b2clogin.com/pasb2c.onmicrosoft.com/B2C_1A_SOCIAL_SIGNIN_KPT',
  AadEditprofileUrl: 'https://pasb2c.b2clogin.com/pasb2c.onmicrosoft.com/B2C_1_PasswordReset',
  LoginButtonBehaviour: LoginBehaviour.B2C,
  buildNumber: '260915.1313',
};
